import React, { createContext, memo, useState } from 'react'
import { createEditorActionBarStore } from './EditorActionBarStore'

export interface EditorActionBarStoreContextProps {
    projectId: string
    editorActionBarStores: Map<
        string,
        ReturnType<typeof createEditorActionBarStore>
    >
}

const EditorActionBarStoreContext = createContext<
    EditorActionBarStoreContextProps | undefined
>(undefined)
export const useEditorActionBarStoreContext = () => {
    const context = React.useContext(EditorActionBarStoreContext)
    if (!context) {
        throw new Error(
            'EditorActionBarStoreContext must be used within a Provider'
        )
    }
    return context
}

export interface EditorActionBarStoreProviderProps {
    projectId: string
    children: React.ReactNode
}

export const EditorActionBarStoreProvider = memo<
    EditorActionBarStoreProviderProps
>(({ projectId = '', children }) => {
    const [storeInstance] = useState<EditorActionBarStoreContextProps>({
        projectId,
        editorActionBarStores: new Map(),
    })
    return (
        <EditorActionBarStoreContext.Provider value={storeInstance}>
            {children}
        </EditorActionBarStoreContext.Provider>
    )
})
